import {
  Box,
  Checkbox,
  Stack,
  Typography,
  TextField,
} from '@atgfr8/atg-ui-tailwind';
import { BasicModal, ToastType } from '@components';
import { createForm } from '@felte/solid';
import { denyCheckRequest } from '@store/Global/service';
import { CheckRequestType } from '@store/Global/types';
import { setSidebarDataStore, sidebarDataStore } from '@store/index';
import { closeModal } from '@store/modals';
import { handleToast } from '@utils/utils';
import { Accessor } from 'solid-js';

type Props = {
  requestCheckData: Accessor<CheckRequestType | undefined>;
};

const DenyCheckRequest = (props: Props) => {
  const { form, data, setFields, handleSubmit } = createForm({
    initialValues: {
      checkCarrierRisk: false,
      checkLoadHistory: false,
      comment: '',
    },
    onSubmit: async () => {
      const payload = {
        comment: denyComment(),
        id: props.requestCheckData()?.requestId as number,
      };
      const response = await denyCheckRequest(payload);
      if (response && response.isSuccess && Boolean(response.value)) {
        handleToast(ToastType.Success, 'Deny check request successfully');
        closeModal('pending-checks');
        const filteredData = sidebarDataStore.pendingChecksData.data.filter(
          (item) => item.id !== props.requestCheckData()?.requestId,
        );
        setSidebarDataStore('pendingChecksData', 'data', filteredData);
      }
    },
  });

  const denyComment = () => {
    let denyComments = '';

    if (data().checkCarrierRisk || data().checkLoadHistory || data().comment) {
      const reasons = [];
      if (data().checkCarrierRisk) reasons.push('Carrier Risk');
      if (data().checkLoadHistory) reasons.push('Load History');
      denyComments =
        reasons.join(' & ') + (data().comment ? ` - ${data().comment}` : '');
      denyComments = `Reason for Denial: ${denyComments}`;
    }
    return denyComments;
  };
  return (
    <BasicModal
      title="Deny Request"
      id={'deny-pending-checks'}
      onSubmit={() => {
        handleSubmit();
      }}
      onClose={() => {
        closeModal('deny-pending-checks');
      }}
      showClose={true}
      width={'700px'}
      footer={true}
    >
      <form ref={form}>
        <Box
          style={{
            height: 'auto',
            'max-height': '580px',
          }}
        >
          <Stack spacing={2}>
            <Typography variant="h6" class="text-xl! font-bold!">
              Check Reasons and add comments below (Optional)
            </Typography>
            <Box class="flex gap-4">
              <Checkbox
                size="xs"
                color="info"
                label="Carrier Risk"
                checked={data().checkCarrierRisk}
                onChange={(e) => {
                  setFields('checkCarrierRisk', e);
                }}
                dataTestId="deny-check-request-carrier-risk-checkboxInput"
              />
              <Checkbox
                size="xs"
                color="info"
                label="Load History"
                checked={data().checkLoadHistory}
                onChange={(e) => {
                  setFields('checkLoadHistory', e);
                }}
                dataTestId="deny-check-request-load-history-checkboxInput"
              />
            </Box>
            <TextField
              label="Comments"
              value={data().comment}
              onChange={(e: string) => setFields('comment', e)}
              multiline
              rows={4}
              dataTestId="deny-check-request-comments-textInput"
            />
          </Stack>
        </Box>
      </form>
    </BasicModal>
  );
};

export default DenyCheckRequest;
